import * as React from 'react';
import { RightSquareOutlined } from '@ant-design/icons';
import { runwayColors } from './styles/globalStyles';
import Text from 'antd/lib/typography/Text';
import Result from 'antd/lib/result';
import Button from 'antd/lib/button';

export interface ComingSoonProps {
    title: string;
    description?: string;
    descriptionNode?: React.ReactNode;
    externalLinkDescription?: string;
    externalLink?: string;
    icon?: React.ReactNode;
    buttonDisabled?: boolean;
}

export const ComingSoon = (props: ComingSoonProps) => {
    const description = props.descriptionNode ?? props.description;

    return (
        <Result
            title={<Text style={{ fontWeight: 600, color: runwayColors.darkTextGrey }}>{props.title}</Text>}
            subTitle={description ?? null}
            icon={props.icon}
            extra={
                props.externalLink && (
                    <Button
                        type="link"
                        href={props.externalLink}
                        target="_blank"
                        disabled={props.buttonDisabled ?? false}
                    >
                        {props.externalLinkDescription}
                        <RightSquareOutlined />
                    </Button>
                )
            }
        ></Result>
    );
};
